import { legacyPlugins } from "/opt/suncore/build/20261103T154933Z-259fdf9d/node_modules/nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}